import { UserButton } from '@clerk/clerk-react';
import { Button } from 'reactstrap';
import { BiSun, BiMoon, BiMenu } from 'react-icons/bi';
import useLightMode from '../../hooks/useLightMode';
import OrgSwitcher from '../common/OrgSwitcher';

// Clerk's `appearance` is supplied globally via ThemedClerkProvider in main.jsx
// — that way the same palette applies to both the popovers here and the
// full-page management modals that Clerk opens off "Manage account" /
// "Manage organization", which otherwise remain light-mode-only.

export default function Header({ onMenuClick }) {
  const { theme, toggleTheme } = useLightMode();
  const isDark = theme === 'dark-mode';

  return (
    <header className="header">
      {/* Hamburger — opens the Offcanvas nav drawer; visible only <md */}
      <Button
        color="link"
        className="header-menu-toggle d-md-none p-1 d-inline-flex align-items-center justify-content-center"
        onClick={onMenuClick}
        aria-label="Open navigation"
      >
        <BiMenu size={22} />
      </Button>

      <div className="user-section d-flex align-items-center gap-3">
        <Button
          color="link"
          className="theme-toggle p-1 d-inline-flex align-items-center justify-content-center"
          onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? <BiSun size={20} /> : <BiMoon size={20} />}
        </Button>
        {/* OrgSwitcher moves into the nav drawer at <md (see appLayout.jsx) */}
        <div className="d-none d-md-block">
          <OrgSwitcher />
        </div>
        <UserButton
          // Force the inline modal so "Manage account" never redirects
          // to the Clerk-hosted Account Portal (which surfaces an org-
          // creation affordance we can't suppress).
          userProfileMode="modal"
          appearance={{
            elements: {
              userButtonPopoverActionButton__signOut: { display: 'none' },
              // Hide the Organisations tab inside the User Profile modal
              // — org creation/management lives only in our /onboarding
              // (signup) and /settings (members) flows.
              profileSectionPrimaryButton__organizations: { display: 'none' },
              userButtonPopoverActionButton__manageOrganization: { display: 'none' },
              userButtonPopoverActionButton__createOrganization: { display: 'none' },
            },
          }}
        />
      </div>
    </header>
  );
}
